import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";

import { Dropdown } from "components/Dropdown";
import { ProductType } from "constants/hst-constants";

export const StyledDropdownProducts = styled(Dropdown)<ThemeProps>`
  justify-content: flex-start;

  width: -webkit-fill-available;

  .products-dropdown {
    width: -webkit-fill-available;
  }

  .dropdown-header {
    background-color: transparent;
    width: 100%;

    h4 {
      color: ${({ theme }) => theme.palette.neutral.white};
    }

    i {
      margin-right: 1rem;
    }
  }

  ul {
    bottom: 2rem;
    left: 6rem;
    top: unset;
  }

  h4 {
    font-weight: ${({ theme }) => theme.font.weight.normal};
    font-size:  ${({ theme }) => theme.font.size._14};

    div:first-child {
      i {
        display: none;
      }
    }
  }
`;

interface StyledProductRowProps extends ThemeProps {
  $productType: ProductType;
}

export const StyledProductRow = styled.div<StyledProductRowProps>`
  width: 100%;
  display: flex;
  column-gap: 1rem;
  flex-direction: row;
  align-items: center;

  color: ${({ $productType, theme }: StyledProductRowProps) => {
    switch ($productType) {
      case ProductType.BUSINESS:
        return theme.palette.secondary.brand;
      default:
        return theme.palette.neutral.black;
    }
  }};

  > i {
    display: ${({ $productType }: StyledProductRowProps) =>
      $productType === ProductType.REGULAR ? "none" : "initial"};
  }
`;
